export default __webpack_public_path__ + "static/media/3.51f45518.png";